import React, { useEffect } from "react";
import RekapBantuan from "../../componen/bantuan/RekapBantuan";
import { RekapTransaksiBantuan } from "../../componen/bantuan/RekapTransaksiBantuan";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMeAdmin } from "../../fitur/AuthSlice";
import { Layout } from "../../layout/Layout";

export const RekapTransaksiBantuanPages = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.authAdmin);

  useEffect(() => { dispatch(getMeAdmin()); }, [dispatch]);
  useEffect(() => { if (isError) navigate("/"); }, [isError, navigate]);

  return (
    <Layout>
      <RekapTransaksiBantuan />
    </Layout>
  );
};
